// extracted by mini-css-extract-plugin
export default {"editorContainer":"WorkspaceEditor_editorContainer__8eT20","titleInput":"WorkspaceEditor_titleInput__s9XnR","blockEditor":"WorkspaceEditor_blockEditor__uu5Ye"};